import EventEmitter from "events";

export default class Size extends EventEmitter {
  width: number = 0;
  height: number = 0;
  private useFixedSize: boolean = false;
  private fixedWidth?: number;
  private fixedHeight?: number;

  constructor(options?: { width?: number, height?: number }) {
    super();

    // 고정 크기가 제공되었는지 확인
    if (options?.width !== undefined || options?.height !== undefined) {
      this.useFixedSize = true;
      this.fixedWidth = options.width;
      this.fixedHeight = options.height;
    }

    this.updateSizes();

    // 고정 크기가 아닌 경우에만 리사이즈 이벤트 리스너 추가
    if (!this.useFixedSize) {
      window.addEventListener("resize", () => {
        this.updateSizes();
        this.emit("resize");
      });
    }
  }

  updateSizes() {
    if (this.useFixedSize) {
      // 고정 크기 사용
      this.width = this.fixedWidth ?? window.innerWidth;
      this.height = this.fixedHeight ?? window.innerHeight;
    } else {
      // 윈도우 크기 사용 (기본 동작)
      this.width = window.innerWidth;
      this.height = window.innerHeight;
    }
    // pixelRatio는 고정값 사용
    //화면 떨림을 만드는듯
    // document.documentElement.style.setProperty("--100vh", `${this.height}px`);
  }

  // 크기 업데이트 메서드
  setSize(width?: number, height?: number) {
    if (width !== undefined || height !== undefined) {
      this.useFixedSize = true;
      if (width !== undefined) this.fixedWidth = width;
      if (height !== undefined) this.fixedHeight = height;
    } else {
      // 인자가 없으면 윈도우 크기 기반으로 되돌림
      this.useFixedSize = false;
      this.fixedWidth = undefined;
      this.fixedHeight = undefined;
    }

    this.updateSizes();
    this.emit("resize");
  }

  // 윈도우 크기 기반으로 되돌리는 메서드
  resetToWindowSize() {
    this.useFixedSize = false;
    this.fixedWidth = undefined;
    this.fixedHeight = undefined;
    this.updateSizes();
    this.emit("resize");
  }
}